<style scoped>  

  @media only screen and (min-width: 991px) {
    .inline.fields {
      margin-top: -10px !important;
    }
    .chk-m-l-15 {
      margin-left: 15px !important;
    }
    .input.fields {
      margin-top: 20px !important;
    }
  }

</style>

<template>

  <div>

    <div :id="_uid" class="ui small modal" :class="modalSelector">
      <div class="ui header">
        Gerar PDF do Laudo
      </div>
      <div class="content">
        <div class="ui form">        
          <div class="fields">
            <div class="sixteen wide field">
              <label class="form-label">Cabeçalho</label> 
            </div> 
          </div>
          <div class="inline fields">
            <div class="field">
              <div class="ui radio checkbox cert-pdf-layout-checkbox">
                <input type="radio" class="hidden" value="default" v-model="layout">
                <label><i class="circle orange icon"></i>Padrão Simavet</label>
              </div>
            </div>
            <div v-if="$isSimavet()" class="field">
              <div class="ui radio checkbox cert-pdf-layout-checkbox chk-m-l-15">
                <input type="radio" class="hidden" value="blank" v-model="layout">
                <label><i class="circle outline icon"></i>Em branco</label>
              </div>
            </div>
            <div v-if="cert.customer.logo" class="field">
              <div class="ui radio checkbox cert-pdf-layout-checkbox chk-m-l-15">
                <input type="radio" class="hidden" value="customer" v-model="layout">
                <label><i class="circle teal icon"></i>Logotipo da clínica</label>
              </div>
            </div>         
          </div>                    
        </div>
      </div>
      <div class="actions">
        <button class="ui basic cancel button"> 
          <i class="times icon"></i> Cancelar
        </button>              
        <a class="ui blue button" :class="{ loading }" :href="pdfLink" target="_blank" @click="hide()">
          <i class="checkmark icon"></i> Confirmar
        </a>
      </div>
    </div>

  </div>
  
</template>

<script>

  import moment from "@/utils/moment"
  import modalDialog from "@/mixins/modal-dialog"

  export default {

    name: "CertPrintModal",

    mixins: [modalDialog],

    data() {
      return {
        layout: "default",
        authToken: "",
        date: moment().format("YYYY-MM-DD"),
        time: moment().format("HH:mm"),
      }
    },

    props: ["cert"],

    mounted() {

      if (this.cert.customer.logo)
        this.layout = "customer"

      $(".cert-pdf-layout-checkbox").checkbox()
    },

    computed: {

      pdfLink() {

        let url = `${process.env.VUE_APP_API_URL}/certs/${this.cert.id}/pdf`

        url += `?authToken=${this.authToken}&layout=${this.layout}`
        url += `&dateTime=${this.date}T${this.time}`

        return url
      },
    },

    methods: {

      async onShow() {

        this.loading = true

        try {

          this.authToken = await this.$store.state.auth.fbUser.getIdToken(true)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },
    },
  }

</script>
